<script>
// import ...
let active = false;

function changeActive() {
	active = !active;
}


function closeActive() {
	active = false;
}

</script>


<style>

#errors-navbar {

}

</style>


<nav class="navbar is-fixed-top" id="errors-navbar">

	<div class="container">

		<div class="navbar-brand">

			<a href="/auth/login" class="navbar-item">
				<img src="/img/logo.png" style="width: 37px !important;">
				<span>Coaches</span>
			</a>

			<a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbar-items" on:click={changeActive} class:is-active={active}>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
				<span aria-hidden="true"></span>
			</a>

		</div>


		<div class="navbar-menu" id="navbar-items" class:is-active={active}>

			<div class="navbar-start">

				<!-- <a class="navbar-item" href="#">

				</a> -->

			</div>


			<div class="navbar-end">

				<a class="navbar-item" href="/auth/login" on:click={closeActive}>
					<span>Login</span>
					<!-- if else ... -->
				</a>

			</div>


		</div>


		<!-- only logo... -->

		<!-- right side: (if logged in: Home, or else: Logout) -->

	</div>

</nav>

